
























import { AD_TYPE } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { defineComponent, ref, computed } from '@vue/composition-api';
import leadAdsVideoImg from '@tt4b/ttam-assets/src/images/creative/lead-ads-video.png';

const { SINGLE_VIDEO } = AD_TYPE;
const name = 'ttam-ad-format-lead-ad-type';

export default defineComponent({
  name,

  setup() {
    const isHover = ref(false);

    // LeadAds 只支持TT版位，因此只有SingleVideo的广告版式
    const adTypeInfo = computed(() => ({
      type: SINGLE_VIDEO.value,
      icon: 'single-video-ads-icon',
      title: i18n.t('module_ad_type_single_video'),
      desc: i18n.t('module_lead_ads_video_desc'),
      img: leadAdsVideoImg,
      hoverImg: 'https://lf16-ttmp.byteintlstatic.com/obj/goofy-sg/panda/dist/statics/images/lead-ads-hover.gif',
    }));

    function showHoverImg() {
      isHover.value = true;
    }
    function hideHoverImg() {
      isHover.value = false;
    }

    return {
      name,
      isHover,
      adTypeInfo,
      showHoverImg,
      hideHoverImg,
    };
  },
});
